import { render, staticRenderFns } from "./InsuranceForm.vue?vue&type=template&id=168eecb4&scoped=true&"
import script from "./InsuranceForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceForm.vue?vue&type=style&index=0&id=168eecb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168eecb4",
  null
  
)

export default component.exports